<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Tipo(s) de Quadro(s):"
    id="selectEvento"
    placeholder="Selecione o(s) Tipo(s) de Quadro(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectTipoQuadro',
  mixins: [useReactiveModelMixin('value')],
  data () {
    return {
      listOptions: [
        { text: 'Vendas', value: 'VENDA' },
        { text: 'Operações', value: 'OPERACAO' },
        { text: 'Cobranças', value: 'COBRANCA' },
        { text: 'Ajuizamento', value: 'AJUIZAMENTO' }
      ]
    }
  },
  props: {
    allSelected: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.allSelected) {
      this.localValue = ['VENDA', 'OPERACAO', 'COBRANCA', 'AJUIZAMENTO']
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoQuadro.vue